export default __webpack_public_path__ + "public/images/style-no.svg";